import React from "react";
import './Otherdevices.css';
import Sorry from './sorry.png';
function Otherdevices(){
    return(
        <div className="Otherdevices">
            <div className="Image">
                <img src={Sorry} alt="" />
            </div>
        </div>
    )
};
export default Otherdevices;